import {UserProfile} from "./UserProfileStore";
import {PaymentMethod} from "./PaymentMethodStore";
import {apiClient} from "../connection/BlinkApiClient";
import {GlobalState} from "../../stem-core/state/State";


class AdminUser extends UserProfile {
    getPaymentMethods(): PaymentMethod[] {
        return PaymentMethod.filter(item => item.userId === this.id);
    }
}

// Override the base store
GlobalState.stores.set("userprofile", AdminUser);

export async function apiAdminFetchUser(userId: number): Promise<AdminUser> {
    const response = await apiClient.get("admin/users/user_data/", {userId});
    return AdminUser.loadObject(response);
}
